import request from '@/common/request'

class PermissaoService {
  getAll() {
    return request.get('/permissoes')
  }

  create(data) {
    return request.post('/permissoes', data)
  }

  update(id, data) {
    return request.patch(`/permissoes/${id}`, data)
  }

  deleteById(id) {
    return request.delete(`/permissoes/${id}`)
  }

  getAllRotinasByPermissao(permissaoId) {
    return request.get(`/permissoes/${permissaoId}/rotinas`)
  }

  getAllRotinasByPermissoes(permissoesIds) {
    return request.get(`/permissoes/rotinas`, permissoesIds)
  }

  getOperacoesByUsuarioAndRotina(usuarioId, rotinaId) {
    return request.get(`/permissoes/usuarios/${usuarioId}/rotinas/${rotinaId}/operacoes`)
  }

  addRotinaRelationship(permissaoId, data) {
    return request.put(`/permissoes/${permissaoId}/rotinas`, data)
  }

  removeRotinaRelationship(permissaoId, rotinaId) {
    return request.delete(`/permissoes/${permissaoId}/rotinas/${rotinaId}`)
  }
}

export default new PermissaoService()
